export const _cms_host = 'https://cms.houseofyards.com';


////////// env start //////////
export const _redirect_uri = 'http://localhost:5000';
export const _ppm_host = 'http://localhost:5550';
export const _api_host = 'http://localhost:8000';
export const _bpm_domain = 'localhost:5555';
export const _recaptcha_key = '6LczIjMgAAAAAA7Iat2xKfRAz7HLG5cHI-lno56y';
export const _STRIPE_PUBLIC_KEY = 'sk_test_51N3mlkFvFZpuAfdh6p9ZEHhkZXTyneStiJowIMSJfJaNgSgjdZ5Pz3bT1Y6p7IH5plonHILWf5DnBxyz9LyTg41y00uX7QHnjL';
////////// env end //////////